import { getHasImmediateNra, getMinFutureNra } from './nextRequestAt';

import type { QueryState } from '@web-platform/shared-universal-types/src/redux/state/network/queries';
import type { Nullable } from '@web-platform/shared-universal-types-utils/src/utils';

type Output = {
  minNextRequestAt: Nullable<number>;
  immediateQueryState: QueryState;
};

export const reduceQueryStateToNextQueries = (state: QueryState, nowTimestamp: number): Output =>
  Object.keys(state).reduce(
    (acc: Output, key) => {
      const queryItem = state[key];
      const minFutureNra = getMinFutureNra(queryItem, nowTimestamp);

      if (!queryItem.inFlight && getHasImmediateNra(queryItem, nowTimestamp)) {
        acc.immediateQueryState[key] = queryItem;
      }

      if (minFutureNra && (!acc.minNextRequestAt || minFutureNra < acc.minNextRequestAt)) {
        acc.minNextRequestAt = minFutureNra;
      }

      return acc;
    },
    {
      minNextRequestAt: null,
      immediateQueryState: {},
    },
  );
